import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrManager } from 'ng6-toastr-notifications';
import { PayService } from 'src/app/models/pay-service';
import { ServiceType } from 'src/app/models/service-type';
import { UnitTypeService } from 'src/app/models/unit-type-service';
import { Unity } from 'src/app/models/unity';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { ServiceService } from 'src/app/services/service.service';
import { UnityService } from 'src/app/services/unity.service';
import { getUtilitarianColumns, getConfigureUnitType } from 'src/app/src/utl';

@Component({
  selector: 'app-unity-verification',
  templateUrl: './unity-verification.component.html',
  styleUrls: ['./unity-verification.component.css']
})
export class UnityVerificationComponent implements OnInit {

  user:User;

  loading:boolean = false;

  pay_services:PayService[] = [];
  pay_services_temp:PayService[] = [];
  pay_services_actives:PayService[] = [];
  type:string = 'motor';

  pay_service:PayService = new PayService();
  pay_service_active:PayService = new PayService();
  service_types:ServiceType[] = [];
  service_type:ServiceType = new ServiceType();
  unit_type_services:UnitTypeService[] = [];
  unities:Unity[] = [];
  unities_temp:Unity[] = [];
  unity:Unity = new Unity();

  service_type_column:any[] = [];

  isMachinery:boolean = false;

  files:File[] = [];

  constructor(private authServ:AuthService, private unityServ:UnityService, private serviceServ:ServiceService, private modalService:NgbModal, private toastr:ToastrManager) { }

  ngOnInit() {
    this.user = this.authServ.getActualUser();
    this.isMachinery = this.authServ.isExactly('machinery') || this.authServ.isExactly('staff');
    this.getPayServices();
  }

  getPayServices(){
    this.loading = true;
    this.serviceServ.getPayServices(this.isMachinery).subscribe(pay_services=>{
      this.pay_services = pay_services.filter(pay=> pay.service_type_id == 6 || pay.service_type_id == 7);
      this.unitTypeServices();
    },error=>{
      console.log(error);
      this.toastr.errorToastr('No se pudo recuperar los registros de los pagos de servicios realizados.');
      this.loading = false;
    });
  }

  filterPayServices(){
    this.pay_services_temp = this.pay_services.filter(pay=> getConfigureUnitType().findIndex(config=>config.unit_type_id == pay.unity.unit_type_id && config.type == this.type) != -1);
  }

  unitTypeServices(){
    this.loading = true;
    this.serviceServ.getUnitTypeService().subscribe(unit_type_services=>{
      this.unit_type_services = unit_type_services.filter(unit=> unit.service_type_id == 6 || unit.service_type_id == 7);
      this.getUnities();
    },error=>{
      console.log(error);
      this.loading = false;
    });
  }

  getUnities(){
    this.loading = true;
    this.unityServ.getFilteredUnities().then(unities=>{
      this.unities = unities;
      this.getServiceTypes();
    }).catch(error=>{
      console.log(error);
      this.toastr.errorToastr('No se pudo recuperar los registros de las unidades.');
      this.loading = false;
    });
  }

  getServiceTypes(){
    this.loading = true;
    this.serviceServ.getServiceTypes().subscribe(service_types=>{
      this.service_types = service_types.filter(ser=> ser.id == 6 || ser.id == 7);
      this.filterPayServices();
      this.loading = false;
    },error=>{
      console.log(error);
      this.toastr.errorToastr('No se pudo recuperar los registros de los tipos de servicios.');
      this.loading = false;
    });
  }

  openModal(modal){
    this.pay_service_active = new PayService();
    this.filterColumns();
    this.modalService.open(modal, { size: 'lg', centered: true});
  }

  filterColumns(){
    this.unities_temp = this.unities.filter(unity=> unity.active && this.unit_type_services.findIndex(unit=>unit.unit_type_id == unity.unit_type_id && unit.service_type_id == this.service_type.id) != -1);
    let column = getUtilitarianColumns().find(column => column.type == this.type && column.id == this.service_type.id);
    this.service_type_column = [];
    if(column && this.unities_temp.length > 0 && this.pay_service.unity_id){
      this.service_type_column = column.columns;
    }
    this.pay_service_active.id = 0;
    this.pay_services_actives = this.pay_services.filter(pay=> pay.service_type_id == this.service_type.id && pay.unity_id == this.pay_service.unity_id);
  }
  
  storePayService(){
    this.loading = true;
    this.pay_service.service_type_id = this.service_type.id;
    this.serviceServ.storePayService(this.pay_service).subscribe(pay_service=>{
      if(this.pay_service_active.id){
        this.pay_service_active.active = false;
        this.serviceServ.updatePayService(this.pay_service_active).subscribe(pay=>{
          this.loadFiles(pay_service);
          this.pay_service = new PayService();
          this.pay_service_active = new PayService();
          this.toastr.successToastr('Se agrego correctamente el pago de la verificación.');
          this.modalService.dismissAll();
          this.ngOnInit();
        },error=>{
          console.log(error);
          this.toastr.errorToastr('No se pudo cerrar el registro del pago a sustituir.');
          this.loading = false;
        })
      }else{
        this.loadFiles(pay_service);
        this.pay_service = new PayService();
        this.toastr.successToastr('Se agrego correctamente el pago de la verificación.');
        this.modalService.dismissAll();
        this.ngOnInit();
      }
    },error=>{
      console.log(error);
      this.toastr.errorToastr('No se pudo crear el registro del pago de verificación.');
      this.loading = false;
    });
  }

  readFiles(files){
    this.files = files;
    console.log(this.files.length);
  }

  loadFiles(pay_service){
    this.loading = true;
    if(this.files.length == 0){
      this.loading = false;
    }else{
      let count = 0;
      for (let index = 0; index < this.files.length; index++) {
        this.serviceServ.loadFilePayService(pay_service, this.files[index]).subscribe(resp=>{
          count++;
          if(count == this.files.length){
            this.toastr.successToastr("Documento(s) cargado(s) correctamente.");
            this.files = [];
            this.loading = false;
          }
        },error=>{
          this.toastr.errorToastr("No se pudo cargar el documento " + this.files[index].name);
          this.loading = false;
        });
      }
    }
  }
}
